/*
 * @Author: bbqin
 * @Date: 2022-01-04 10:27:29
 * @LastEditTime: 2022-07-08 11:27:09
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\TableNext\adapter\utils\handleBeforeEvent.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { beforeAndAfter } from '../../../../FastExtend/utils';

export function handleBeforeEvent({ row, column, moduleId, callback, type }) {
    let { dataIndex } = row,
        { attrcode } = column;

    let fxParams = {
        moduleId,
        record: row,
        attrcode,
        methods: this.output,
        column,
        index: dataIndex,
        val: row.values[attrcode],
    };

    return beforeAndAfter(
        this,
        { 
            moduleId, 
            attrcode: attrcode, 
            fxType: type, 
            fxParams,
        },
        () => callback(),
    );
}